import * as yup from 'yup';

export interface FormValues {
  firstName: string;
  lastName: string;
}

export const validation = yup.object().shape({
  firstName: yup
    .string()
    .nullable()
    .when('$hasRedtailImport', {
      is: false,
      then: schema => schema.required('Please specify a first name'),
      otherwise: schema => schema,
    }),
});

export interface RedtailClientOption {
  label: string;
  value: number | null;
  OnboardingEndpoint?: string | null;
}
